// Remove the records of one type from the legacy store, except the ones the
// server just sent with the page.
//
// The store is built once per document and survives a Turbo visit, so a record
// the server has stopped sending would otherwise stay until a full reload.
export default function pruneStoreRecords(store, type, keepIds) {
  const keep = keepIds.map(String)

  store.getCollection(type).pluck('id')
    .filter((id) => !keep.includes(String(id)))
    .forEach((id) => store.setData(type, id, null))
}
